import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})

export class UserService {

  private baseURL: string;

  private marketInfoSubject = new BehaviorSubject<any>(null);
  marketInfo$ = this.marketInfoSubject.asObservable();

  private vendorInfoSubject = new BehaviorSubject<any>(null);
  vendorInfo$ = this.vendorInfoSubject.asObservable();

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.baseURL = environment.apiBaseUrl;
  }

  public options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  setSessionData(marketId: string, vendorId: string) {
    if (!sessionStorage.getItem('tabId')) {
      sessionStorage.setItem('tabId', this.generateUUID());
    }
    const tabId = sessionStorage.getItem('tabId');
    const key1 = `marketId-${tabId}`;
    const key2 = `vendorId-${tabId}`;
    localStorage.setItem(key1, marketId);
    localStorage.setItem(key2, vendorId);
  }

  getMarketId(): string | null {
    const tabId = sessionStorage.getItem('tabId');
    const key1 = `marketId-${tabId}`;
    return localStorage.getItem(key1);
  }

  getVendorId(): string | null {
    const tabId = sessionStorage.getItem('tabId');
    const key2 = `vendorId-${tabId}`;
    return localStorage.getItem(key2);
  }

  clearSession() {
    if (!sessionStorage.getItem('tabId')) {
      sessionStorage.setItem('tabId', this.generateUUID());
    }
    const tabId = sessionStorage.getItem('tabId');
    const key1 = `marketId-${tabId}`;
    const key2 = `vendorId-${tabId}`;
    localStorage.removeItem(key1);
    localStorage.removeItem(key2);
  }

  getToken(userData): Observable<any> {
    const url = `${this.baseURL}/user`;
    return this.http.post<any>(url, userData, this.options)
      .pipe(
        map(res => {
          if (res.Token) {
            this.authService.isLoggedIn = true;
            localStorage.setItem('token', res.Token);
            return res;
          }
          else {
            this.authService.isLoggedIn = false;
          }
        }),
        catchError(this.handleError)
      );
  }

  clearToken(): void {
    localStorage.removeItem('token');
    this.authService.isLoggedIn = false;
  }

  forgotPassword(marketId, email): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/user/VendorWILoginForgotPassword?marketId=${marketId}`
    return this.http.post<any>(url, { email }, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  resetVendorWILoginPassword(marketId, vendorResetPassModel): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/user/ResetVendorWILoginPassword?marketId=${marketId}`
    return this.http.post<any>(url, vendorResetPassModel, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getVendorById(vendorId: number, marketId: number): Observable<any> {
    const currentVendor = this.vendorInfoSubject.value;
    if (
      currentVendor &&
      currentVendor.VendorId === vendorId
    ) {
      return of(currentVendor);
    }

    return this.http.get<any>(
      `${this.baseURL}/General/GetVendorInfoById?vendorId=${vendorId}&marketId=${marketId}`,
      { observe: 'response' }
    ).pipe(
      map(res => res.body),
      tap(result => {
        this.vendorInfoSubject.next(result);
      }),
      catchError(this.handleError)
    );
  }

  getMarketName(marketId: number): Observable<any> {
    if (this.marketInfoSubject.value) {
      return of(this.marketInfoSubject.value);
    }

    return this.http.get<any>(
      `${this.baseURL}/General/GetMarketName?marketId=${marketId}`,
      { observe: 'response' }
    ).pipe(
      map(res => res.body),
      tap(result => {
        this.marketInfoSubject.next(result);
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      // this.appinsights.logEvent(errMessage);
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
} 